import { Injectable, OnDestroy } from "@angular/core";
import _ from "lodash";
import { Subject } from "rxjs";

/** @deprecated */
export enum PAGES_NAME {
  ORDER_DETAIL_GUEST = 0,
  GUEST_DETAIL = 1,
  GUEST_SIMILAR = 2,
  ORDER_DETAIL_BASIC = 3,
  HOUR_ORDER_DETAIL_BASIC = 4,
  CREATE_ORDER = 5
}

/** @deprecated */
interface Node<T> {
  next: Node<T> | null;
  pre: Node<T> | null;
  element: T;
}
/** @deprecated */
export interface JumpData {
  page: PAGES_NAME;
  code?: string; // 入住单号
  id?: number | string; // 房客ID
  tab?: number;
  showBack?: boolean;
  refresh?: boolean;
}
/** @deprecated */
class LianBiao<T> {
  length = 0;
  head: Node<T> | null = null;
  rear: Node<T> | null = null;
  append(element: Node<T>) {
    const node: Node<T> = element;
    if (this.head === null) {
      this.head = node;
      this.rear = node;
    } else {
      let current = this.head;
      while (current.next) {
        current = current.next;
      }
      current.next = node;
      node.pre = current;
      this.rear = node;
    }
    this.length++;
  }
}
/** @deprecated */
class LianBiaoNode<T> implements Node<T> {
  element: T;
  next: Node<T> | null = null;
  pre: Node<T> | null = null;
  constructor(element: T, Linext: Node<T> | null = null, Lipre: Node<T> | null = null) {
    this.element = element;
    this.next = Linext;
    this.pre = Lipre;
  }
}

export enum PageName {
  GuestList = "GuestList",
  GuestDetail = "GuestDetail",
  GuestSimilar = "GuestSimilar",
  OrderDetail = "OrderDetail",
  HourOrderDetail = "HourOrderDetail",
  RateDetail = "RateDetail"
}

export interface Page {
  name: PageName;
  payload?: any;
}

/** @TODO @FIXME 该模块放置全局通用服务，不涉及业务逻辑。此服务需放置到具体业务模块下 */

@Injectable({
  providedIn: "root"
})
export class SwitchPageService implements OnDestroy {
  /** @deprecated */
  currentNodeRaw$ = new Subject<JumpData>();
  /** @deprecated */
  currentNode: LianBiaoNode<JumpData>;

  pages: Page[] = [];
  switchPageRaw$ = new Subject<Page>();
  constructor() {
    // this.switchPage$.subscribe();
  }

  navigate(name: PageName, payload?: any) {
    console.log("================================================================");
    console.log("before navigate: pages: ", JSON.parse(JSON.stringify(this.pages)));
    const page = { name, payload };

    if (!this.isActive(name)) {
      this.pushState(page);
    } else {
      this.replaceState(page);
    }

    const current = _.last(this.pages);
    console.log("switch page: ", current);
    this.switchPage(current);
    console.log("after navigate: pages: ", JSON.parse(JSON.stringify(this.pages)));
  }

  back() {
    console.log("back: pages: ", JSON.parse(JSON.stringify(this.pages)));
    this.pages.pop();

    const pre = this.pages.pop();
    if (pre) {
      this.navigate(pre.name, pre.payload);
    }
  }

  go(step: number) {
    switch (step) {
      case -1:
        this.back();
        break;
      case 0:
        this.pages = [];
        this.switchPage(null);
        break;
    }
  }

  private switchPage(page: Page) {
    this.switchPageRaw$.next(page);
  }

  private pushState(page: Page) {
    this.pages.push(page);
  }

  private replaceState(page: Page) {
    const current = this.pages.pop();
    // current.payload = { ...current.payload, ...page.payload };
    _.merge(current.payload, page.payload);

    this.pages.push(current);
  }

  private isActive(name: PageName) {
    const current = _.last(this.pages);
    return _.get(current, "name") === name;
  }

  ngOnDestroy() {}
}
